import script from "./ReleaseNotesPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./ReleaseNotesPanel.vue?vue&type=script&setup=true&lang=js"

import "./ReleaseNotesPanel.vue?vue&type=style&index=0&id=74f2a274&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74f2a274"]])

export default __exports__